import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Button, Icon } from 'elements';

import styles from './durationSlider.scss';

const DurationSlider = ({ handleUp, handleDown, active, selected, previous, next }) => {
  return (
    <div className={styles.durationWrapper}>
      <Button className={styles.button} onClick={handleUp}>
        <Icon name="icon-up"/>
      </Button>
      <span className={classnames(styles.interval, styles.inactive)} onClick={handleUp}>
              {previous} {active > 0 ? 'Minutes' : ''}
            </span>
      <span className={classnames(styles.interval, styles.active)}>
              {selected} Minutes
            </span>
      <span className={classnames(styles.interval, styles.inactive)} onClick={handleDown}>
              {next} {active < 6 ? 'Minutes' : ''}
            </span>
      <Button className={styles.button} onClick={handleDown}>
        <Icon name="icon-down"/>
      </Button>
    </div>
  )
};

DurationSlider.propTypes = {
  handleUp: PropTypes.func.isRequired,
  handleDown: PropTypes.func.isRequired,
  active: PropTypes.number,
  selected: PropTypes.number,
  previous: PropTypes.number,
  next: PropTypes.number,
};

export { DurationSlider };



// WEBPACK FOOTER //
// ./src/elements/durationSlider/durationSlider.js